import { COLUMNS_IDENTIFIERS, COLORS } from "../../../components/components.constants";
import { calculateEffectivePurchase } from "../../../utils/utils";

const sourceColoringStrategy = (context) => {
  const { productInputs, source, effectivePurchase, packToUnitRatio } = context;
  const colors = {};

  const sourceValue = productInputs?.[source];
  const expected = calculateEffectivePurchase(sourceValue, packToUnitRatio);

  if (Number(expected) === Number(effectivePurchase)) {
    colors[source] = COLORS.GREEN_CURRENT_TABLE_VALUE;
    colors[COLUMNS_IDENTIFIERS.EFFECTIVE_PURCHASE] = COLORS.GREEN_CURRENT_TABLE_VALUE;
  }

  return colors;
};

const preferredSourceColoringStrategy = (context) => {
  const { 
    effectivePurchase, 
    isOrderHystoryPage, 
    preferedSource,
    packToUnitRatio,
    purchaseRec7,
    purchaseRec14,
    purchaseRec21
  } = context;

  const colors = {};

  const recs = [
    { key: COLUMNS_IDENTIFIERS.PURCHASE_REC_7, value: purchaseRec7 },
    { key: COLUMNS_IDENTIFIERS.PURCHASE_REC_14, value: purchaseRec14 },
    { key: COLUMNS_IDENTIFIERS.PURCHASE_REC_21, value: purchaseRec21 },
  ];

  const resolvedPreferred = isOrderHystoryPage 
    ? `purchaseRec${preferedSource}` 
    : preferedSource;

  for (const rec of recs) {
    if (rec.key !== resolvedPreferred) continue;

    const expected = calculateEffectivePurchase(Number(rec.value), packToUnitRatio);

    if (Number(expected) === Number(effectivePurchase)) {
      colors[rec.key] = COLORS.GREEN_CURRENT_TABLE_VALUE;
      colors[COLUMNS_IDENTIFIERS.EFFECTIVE_PURCHASE] = COLORS.GREEN_CURRENT_TABLE_VALUE;
      break;
    }
  }

  return colors;
};

export const selectColoringStrategy = (source) => {
  return source ? sourceColoringStrategy : preferredSourceColoringStrategy;
};